import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { paramsGUID } from 'app/shared/cx-utils/cx-params-guid/cx-params-guid';
import { filter, map, takeWhile, tap } from 'rxjs/operators';
import CxApiMetadataActions from './store/actions/cx-api-metadata.actions';
import { CxApiMetadataEntity, CxApiMetadataState } from './store/reducers/cx-api-metadata.reducer';
import * as cxApiMetadataSelector from './store/selectors/cx-api-metadata.selector';
import { TypedAction } from '@ngrx/store/src/models';

export type CxApiMetadataStrategy = 'cache-only' | 'network-only' | 'cache-first';

@Injectable({
  providedIn: 'root',
})
export class CxApiMetadataService {
  constructor(private store: Store<CxApiMetadataState>) {}

  public selectApiMetadata$(request: Object, namespace = '__default') {
    const id = paramsGUID(request, namespace);

    return this.store.select(cxApiMetadataSelector.selectCxApiMetadataById(), { id }).pipe(
      tap((metadataEntity) => {
        if (!metadataEntity) {
          this.store.dispatch(CxApiMetadataActions.initEntity({ id }));
        }
      }),
      filter<CxApiMetadataEntity>(Boolean),
    );
  }

  public connectMetadata$(action: TypedAction<any>, strategy: CxApiMetadataStrategy = 'cache-first') {
    const { type, ...rest } = action;

    return this.selectApiMetadata$(rest, type).pipe(
      takeWhile((metadataEntity) => !metadataEntity.hasError, true),
      map((metadataEntity) => {
        if (strategy !== 'cache-only') {
          if (
            !metadataEntity.isLoading &&
            (strategy === 'network-only' || (strategy === 'cache-first' && Date.now() > metadataEntity.expiresAt))
          ) {
            this.store.dispatch(CxApiMetadataActions.fetchEntity({ id: metadataEntity.id }));
            this.store.dispatch({ ...action, cxApiMetadata: { id: metadataEntity.id, ttl: 3600 } });
          }
        }

        return metadataEntity;
      }),
      filter<CxApiMetadataEntity>(Boolean),
    );
  }
}
